<template>
    <div class="row justify-content-sm-center">
        <div class="col-sm-6">
            <form class="shaded" @submit.prevent.stop="processForm" novalidate>
                <div class="form-group" :class="{ error: $v.form.brand.$error }">
                    <label class="full">
                        Company brand name
                        <input v-model="form.brand" type="text" placeholder="Company brand name" autofocus @input="$v.form.brand.$touch">
                    </label>

                    <div v-if="$v.form.brand.$error" class="messages">
                        <span v-if="!$v.form.brand.required">Company brand name is required.</span>
                        <span v-if="!$v.form.brand.minLength">Your company brand must have at least 3 characters.</span>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-sm-6" :class="{ error: $v.form.name.$error }">
                        <label class="full">
                            Your first and last name
                            <input v-model="form.name" type="text" placeholder="Please add your name" @input="$v.form.name.$touch">
                        </label>

                        <div v-if="$v.form.name.$error" class="messages">
                            <span v-if="!$v.form.name.required">First and last name are required.</span>
                            <span v-if="!$v.form.name.minLength">Your first and last name must have at least 4 characters.</span>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="positions">
                        <location-fields @locationFieldsChanged="updateLocationFields"></location-fields>
                        <!-- <label class="full">Your position</label>

                        <v-select
                            v-model="selectedPosition"
                            :options="positions"
                            @input="updatePosition"
                            label="description"
                            :searchable="false">
                        </v-select> -->
                    </div>

                </div>

                <div class="form-group" :class="{ error: $v.form.email.$error }">
                    <label class="full">
                        Email
                        <input v-model.trim.lazy="form.email" type="email" placeholder="Your email"  @blur="$v.form.email.$touch">
                    </label>

                    <div v-if="$v.form.email.$error" class="messages">
                        <span v-if="!$v.form.email.required">Email is required.</span>
                        <span v-if="!$v.form.email.email">Must be a valid email</span>
                        <span v-if="!$v.form.email.isUnique">This email is already in use.</span>
                    </div>
                </div>

                <div class="form-group" :class="{ error: $v.form.password.$error }">
                    <label class="full">
                        Password
                        <input v-model.trim="form.password" type="password" placeholder="Your password" @input="$v.form.password.$touch">
                    </label>

                    <div v-if="$v.form.password.$error" class="messages">
                        <span v-if="!$v.form.password.required">Please type a password.</span>
                        <span v-if="!$v.form.password.minLength">Minimum length of 4 characters.</span>
                    </div>
                </div>

                <div class="fs-smaller mt-2">
                    <checkbox class="d-inline" name="terms" value="true" v-model="form.hasAcceptTermsConditions"></checkbox>
                    I accept the

                    <span class="darker underlined pointer" @click="openConditions">Terms of Service and Privacy Policy</span>
                </div>

                <input type="submit" class="btn action widest full" value="Sign up free" :disabled="$v.form.$invalid">

            </form>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import LocationFields from '../LocationFields'
    import Modal from '../../../tools/modal/Modal'

    export default {
        data: function() {
            return {
                step: 1,
                form: {
                    brand: '',
                    name: '',
                    email: '',
                    password: '',
                    hasAcceptTermsConditions: false
                },
                selectedPosition: null
            }
        },
        validations: {
            form: {
                brand: {
                    required,
                    minLength: minLength(3)
                },
                name: {
                    required,
                    minLength: minLength(3)
                },
                email: {
                    required,
                    email,
                    isUnique () {
                        return this.isUniqueEmail;
                    }
                },
                password: {
                    required,
                    minLength: minLength(6)
                },
                hasAcceptTermsConditions: {
                    required,
                    // checkVal(val){
                    //     return val
                    // }
                }
            },
        },
        created: function() {
            this.eventHub.$emit('sidebar', 'signup');
            this.eventHub.$emit('topLink', 'login');

            // If we com from 'back button', fill the form.
            // Else start from scratch

            if (this.accountSetup.email) {
                this.form = this.accountSetup;
            }
            else {
                this.resetAccountSetup('supplier');
            }
        },
        mounted: function() {
            // this.form.brand = 'Pluralo';
            // this.form.name = 'Pluralo Test';
            // this.form.email = 'test@test.com';
            // this.form.password = 'testing';
            // this.form.confirmPassword = this.form.password;
        },
        computed: {
            ...mapGetters([
                'accountSetup'
            ]),
        },
        asyncComputed: {
            async positions() {
                try {
                    let response = await axios.get('/api/settings/GetEmployeeTitleList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.form.selectedPosition = response.data[0];
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            },
            isUniqueEmail: {
                get () {
                    let email = this.form.email;

                    if (this.form.email && email != '') {

                        axios.get(axios.authURL + 'auth/IsEmailFree', {
                            params: {
                                email: email
                            }
                        }).then(response => {
                            if (response && response.status === 200) {
                                return response.data.isSuccessStatusCode;
                            }
                        }).catch(error => {
                            console.log(error.response.data.message);
                        })

                    }

                    return true;
                },
                default: false
            }
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'openModal'
            ]),
            processForm: function() {
                this.form.step = this.step + 1;

                // Update account setup data

                this.updateAccountSetup(this.form);

                // Move on to step 2

                this.$router.push({ name: 'auth.signup.supplier.create' });
            },
            updatePosition: function() {
                this.form.position = this.selectedPosition.id || null;
            },
            updateLocationFields: function(fields) {
                for (var key in fields) {
                    if (fields.hasOwnProperty(key)) {
                        this.form[key] = fields[key];
                    }
                }
            },
            openConditions: function() {
                // this.openModal('TosConditions');
                window.open('https://help.pluralo.com/suppliers.html', '_blank');
            },
        },
        components: {
            vSelect: extendedVSelect,
            LocationFields
        }
    }
</script>



// WEBPACK FOOTER //
// Step1.vue?0c0f69ec